





















































































































import { Vue, servicesURL, headers } from "../../constants/constants";
import axios from "axios";

import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("dish-feedback", {
  data() {
    return {
      staticContent,
      hasError: false,
      liked: false,
      disLiked: false,
      feedBackData: {},
      orderItemReviewRequests: [],
      loading: false,
      showMore: false
    };
  },
  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    basket() {
      return this.$store.getters.getBasket;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    }
  },
  methods: {
   
    showMoreFn(){
      this.showMore=true
    },
    disableDoneBtn() {
      return this.orderItemReviewRequests.find(item => item.action);
    },
    hideModal() {
      this.$root.modalToggler("dish-feedback-modal", "hide");
    },
    like(index) {
      if (!this.orderItemReviewRequests[index].action) {
        this.orderItemReviewRequests[index].action = "LIKE";
      } else {
        this.orderItemReviewRequests[index].action == "DISLIKE"
          ? (this.orderItemReviewRequests[index].action = "LIKE")
          : (this.orderItemReviewRequests[index].action = null);
      }
    },
    disLike(index) {
      if (!this.orderItemReviewRequests[index].action) {
        this.orderItemReviewRequests[index].action = "DISLIKE";
      } else {
        this.orderItemReviewRequests[index].action == "LIKE"
          ? (this.orderItemReviewRequests[index].action = "DISLIKE")
          : (this.orderItemReviewRequests[index].action = null);
      }
    },
    getOrderDishFeedback() {
      axios({
        method: "GET",
        url: servicesURL.getDishFeedback,
        headers: headers
      })
        .then(res => {
          this.feedBackData = res.data;

          res.data.orderItems.map(item => {
            let obj = {
              itemUUID: null,
              action: null
            };
            obj.itemUUID = item.itemUUID;
            obj.action = null;
            this.orderItemReviewRequests.push(obj);
          });
          this.$root.modalToggler("dish-feedback-modal", "show");

     
        }).catch(err=>{
          console.log(err)
        })
      
    },
    addOrderDishFeedback() {
      let dataObjTemp=[]
      this.orderItemReviewRequests.map(item=>{
        item.action?dataObjTemp.push(item):''
      })
      let dataObj = {
        itemReviewRequests: dataObjTemp
      };
      this.loading = true;
      axios({
        method: "POST",
        url: servicesURL.postDishFeedback(this.feedBackData.orderUUID),
        headers: headers,
        data: JSON.stringify(dataObj)
      })
        .then(res => {
          this.loading = false;
          this.$root.modalToggler("dish-feedback-modal", "hide");
          this.$root.modalToggler('feed-back-confirmation','show');
          setTimeout(() => {
          this.$root.modalToggler('feed-back-confirmation','hide');
            
          }, 2000);

        })
        .catch(error => {
          this.loading = false;
        });
    },
    dismissFeedback() {
      this.loading = true;
      axios({
        method: "POST",
        url: servicesURL.dismissDishFeedback(this.feedBackData.orderUUID),
        headers: headers
      })
        .then(res => {
          this.loading = false;
          this.$root.modalToggler("dish-feedback-modal", "hide");
        })
        .catch(error => {
          this.loading = false;
          this.$root.modalToggler("dish-feedback-modal", "hide");
        });
    }
  },

  mounted() {
    this.getOrderDishFeedback();

  }
});
